﻿import { useState } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { FiMapPin } from 'react-icons/fi';
import type { CustomerDetail as CustomerData } from '@/hooks/useCustomerDetail';
import { hasCoordinates } from '@/utils/mapUtils';
import MapModal from '@/components/common/MapModal';

interface Props {
  customer: CustomerData;
}

export default function CustomerDetail({ customer: c }: Props) {
  const isProspect = c.tipologia === 'P';
  const coords = hasCoordinates(c as Record<string, unknown>);
  const [showMap, setShowMap] = useState(false);

  return (
    <>
      <div className="card mb-2 border-0" style={{ fontSize: 11 }}>
        <div className="card-body py-2 px-3">
          <div className="mb-1 d-flex align-items-center gap-2">
            <span>
              <span className="text-muted" style={{ fontSize: 10 }}>[{c.codcliente}]</span>{' '}
              <strong style={{ fontSize: 13 }}>{c.ragsociale}</strong>
            </span>
            {coords && (
              <Button variant="outline-secondary" size="sm" className="btn-icon" style={{ width: 28, height: 28 }}
                onClick={() => setShowMap(true)} title="Vedi su mappa">
                <FiMapPin size={14} />
              </Button>
            )}
          </div>
          <div className="row row-cols-1 row-cols-sm-3 g-2">
            <div className="col">
              <div className="text-muted fw-semibold mb-1" style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Indirizzo</div>
              {c.indirizzo && <div>{c.indirizzo}</div>}
              <div>{[c.cap, c.localita, c.prov].filter(Boolean).join(' ')}</div>
              <div>{[c.regioncountry, c.stato].filter(Boolean).join(' ')}</div>
            </div>
            <div className="col">
              <div className="text-muted fw-semibold mb-1" style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Contatti</div>
              <div>Tel: {c.telefono || '-'}</div>
              <div>Email: {c.email || '-'}</div>
            </div>
            <div className="col">
              <div className="text-muted fw-semibold mb-1" style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5 }}>Info</div>
              {c.salesmanager && (
                <div>SM: {c.salesmanager.cognome} {c.salesmanager.nome} [{c.salesmanager.codice}]</div>
              )}
              <div>
                Zona: {c.zona || '-'} {' '}
                {isProspect
                  ? <Badge bg="" className="text-info border border-info" style={{ fontSize: 9 }}>Prospect</Badge>
                  : <Badge bg="" className="text-success border border-success" style={{ fontSize: 9 }}>Customer</Badge>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      {coords && (
        <MapModal show={showMap} onHide={() => setShowMap(false)}
          lat={coords.lat} lng={coords.lng} title={c.ragsociale}
          address={[c.indirizzo, c.cap, c.localita, c.prov, c.stato].filter(Boolean).join(', ')} />
      )}
    </>
  );
}
